import React, { ChangeEvent, useRef, useState, useEffect } from "react";
import "./ScholarshipResultBanner.scss";
import axios from "axios";
import config from "../../../util/config";
import { useReactToPrint } from "react-to-print";
import Certificate from "../ParticipationCertificate";
import CertificateGenerator from "../Certificates";
import html2canvas from "html2canvas";
import moment from "moment";
import ParticipationCertificate from "../ParticipationCertificate";
import { BaseURLAuth, checkTokenExpiry } from "../../../services/api";
import PopupInfo from "../../../components/popupInfo/popup";
import NewCertificateGenerator from "../NewCertificateGenerator";
import NewParticipationCertificate from "../NewParticipationCertificate";
import ExamNotTaken from "./ExamNotTaken";
import ManavRachanaLogo from "../../../images/scholarship-results/manav-rachn.webp";
import SaiULogo from "../../../images/scholarship-results/sai-logo.webp";
import sVyasaLogo from "../../../images/scholarship-results/svyasa-logo.webp";
import UPESLogo from "../../../images/scholarship-results/upes-logo.webp";
import ShardaLogo from "../../../images/scholarship-results/sharda-university-logo.webp";
import PanditLogo from "../../../images/scholarship-results/pandit-deendayal-logo.webp";
import MgrMedicalLogo from "../../../images/scholarship-results/educationalresearch-logo.webp";
import SaveethaLogo from "../../../images/scholarship-results/SaveethaLogo.webp";
import AnnamacharyaLogo from "../../../images/scholarship-results/annamacharya-university-logo.webp";
import AllianceLogo from "../../../images/scholarship-results/alliance-university-logo.webp";
import RamachandraLogo from "../../../images/scholarship-results/sriher-logo.webp";
import KaveriLogo from "../../../images/scholarship-results/kaveri-university.webp";
import adityaLogo from "../../../images/scholarship-results/aditya-university-logo.webp";
import BennettLogo from "../../../images/scholarship-results/BennettLogo.webp";
import ChandigarhLogo from "../../../images/scholarship-results/chandigarh-logo.webp";
import GoenkaLogo from "../../../images/scholarship-results/gd-coenka-logo.webp";
import MallaLogo from "../../../images/scholarship-results/malla-ready-logo.webp";
import participationPopupImg from "../../../college/assets/participation_popup.png";
import type { SVGProps } from "react";
import { Link } from "react-router-dom";

export function MaterialSymbolsDownloadSharp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5919 5.56754H9.53672V0.284423C9.53672 0.145178 9.42205 0.0386963 9.2828 0.0386963H5.64196C5.50271 0.0386963 5.38804 0.145178 5.38804 0.284423V5.57163H2.33284C2.13626 5.57163 2.02978 5.80917 2.16083 5.9607L7.28423 11.7435C7.37433 11.8417 7.53815 11.8417 7.62825 11.7435L12.7598 5.9607C12.8909 5.80507 12.7844 5.57163 12.5878 5.57163L12.5919 5.56754Z"
        fill="white"
      />
      <path
        d="M14.574 12.3496V15.4622C14.574 15.9905 14.144 16.4246 13.6034 16.4246H1.31301C0.784702 16.4246 0.350586 15.9946 0.350586 15.4622V12.3496C0.350586 11.8213 0.780607 11.3872 1.31301 11.3872C1.84542 11.3872 2.27544 11.8172 2.27544 12.3496V14.4997H12.6451V12.3496C12.6451 11.8213 13.0751 11.3872 13.6075 11.3872C14.1399 11.3872 14.5781 11.8172 14.5781 12.3496H14.574Z"
        fill="white"
      />
    </svg>
  );
}

// ParticipationPopup component
const ParticipationPopup = ({ onClose }: { onClose?: () => void }) => {
  return (
    <div className="max-w-full max-md:mx-8 md:max-w-[685px] mx-auto mt-10 p-6 bg-white rounded-xl shadow-lg text-center">
      <div className="flex flex-col gap-2">
        <img
          src={participationPopupImg}
          alt="Participation Certificate"
          className="w-full max-w-md mx-auto"
          onError={(e) => {
            e.currentTarget.src = "https://via.placeholder.com/400x300?text=Participation+Certificate";
          }}
        />
      </div>
      <button
        onClick={() => onClose?.()}
        className="mt-6 text-[#173CBA] font-semibold hover:underline"
      >
        Close
      </button>
    </div>
  );
};

const logos = [
  {
    imageUrl: ManavRachanaLogo,
    slug: "mriirs-faridabad-manav-rachna-international-institute-of-research-and-studies-faridabad",
    alt: "Manav Rachna University Logo",
  },
  {
    imageUrl: SaiULogo,
    slug: "sai-university-chennai",
    alt: "Sai University",
  },
  {
    imageUrl: sVyasaLogo,
    slug: "s-vyasa-university-global-city-campus-bengaluru",
    alt: "S-VYASA University Logo",
  },
  // {
  //   imageUrl: UPESLogo,
  //   slug: "upes-university-of-petroleum-and-energy-studies",
  //   alt: "UPES University Logo",
  // },
  {
    imageUrl: ShardaLogo,
    slug: "sri-sharada-institute-of-indian-management-research-new-delhi",
    alt: "Sharda Logo",
  },
  {
    imageUrl: PanditLogo,
    slug: "#",
    alt: "Pandit Deendayal Energy University Logo",
  },
  {
    imageUrl: MgrMedicalLogo,
    slug: "dr-mgr-educational-and-research-institute-chennai",
    alt: "Dr. M.G.R. Medical University Logo",
  },
  {
    imageUrl: SaveethaLogo,
    slug: "simats-saveetha-institute-of-medical-and-technical-sciences-chennai",
    alt: "Saveetha University Logo",
  },
  {
    imageUrl: AnnamacharyaLogo,
    slug: "annamacharya-institute-of-technology-and-sciences-kadapa",
    alt: "Annamacharya University Logo",
  },
  // {
  //   imageUrl: AllianceLogo,
  //   slug: "alliance-university-bangalore",
  //   alt: "Alliance University Logo",
  // },
  {
    imageUrl: RamachandraLogo,
    slug: "sri-ramachandra-institute-of-higher-education-and-research-chennai",
    alt: "Sri Ramachandra Institute of Higher Education and Research Logo",
  },
  {
    imageUrl: KaveriLogo,
    slug: "kaveri-university-siddipet",
    alt: "Kaveri University Logo",
  },
  {
    imageUrl: adityaLogo,
    slug: "aditya-university-kakinada",
    alt: "Aditya University Logo",
  },
  // {
  //   imageUrl: BennettLogo,
  //   slug: "bennett-university-greater-noida",
  //   alt: "Bennett University Logo",
  // },
  {
    imageUrl: ChandigarhLogo,
    slug: "chandigarh-university",
    alt: "Chandigarh University Logo",
  },
  {
    imageUrl: GoenkaLogo,
    slug: "#",
    alt: "GD Goenka University Logo",
  },
  {
    imageUrl: MallaLogo,
    slug: "malla-reddy-university-hyderabad",
    alt: "Malla Reddy University Logo",
  },
  {
    imageUrl: MgrMedicalLogo,
    slug: "dr-mgr-educational-and-research-institute-chennai",
    alt: "Dr. M.G.R. Medical University Logo",
  },
  {
    imageUrl: SaveethaLogo,
    slug: "simats-saveetha-institute-of-medical-and-technical-sciences-chennai",
    alt: "Saveetha University Logo",
  },
  {
    imageUrl: AnnamacharyaLogo,
    slug: "annamacharya-institute-of-technology-and-sciences-kadapa",
    alt: "Annamacharya University Logo",
  },
];

interface OtpResponse {
  message: string;
  data: {
    headers: Record<string, string>;
    body: {
      accessToken?: string;
      statusCode?: number;
      message?: string;
    };
  };
}

interface ScholarshipResult {
  isWinner?: boolean;
  cash_prize_scholarship_worth?: string;
  cash_prize?: string;
  college_mentor_worth_services?: string;
  name?: string;
  CategoryName?: string;
  rank?: number;
  applicationId?: number;
  prize?: string;
  statusCode?: number;
  certificateLink?: string;
  message?: string;
}

// Add a new interface for certificate response
interface CertificateResponse {
  certificateUrl?: string;
  message?: string;
  statusCode?: number;
}

const NewScholarshipResultBanner = () => {
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const [mobileNumber, setMobileNumber] = useState<string>("");
  const [otp, setOtp] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [result, setResult] = useState<ScholarshipResult | null>(null);
  const [otpError, setOtpError] = useState<string>("");
  const certificateRef = useRef<HTMLDivElement>(null);
  const [isHovering, setIsHovering] = useState(false);
  const [showExamNotTakenPopup, setShowExamNotTakenPopup] =
    useState<boolean>(false);
  const [certificateUrl, setCertificateUrl] = useState<string | null>(null);
  const [isCertificateLoading, setIsCertificateLoading] =
    useState<boolean>(false);
  const [showCertificateView, setShowCertificateView] =
    useState<boolean>(false);
  const [showParticipationPopup, setShowParticipationPopup] =
    useState<boolean>(false);

  const closeParticipationPopup = () => {
    setShowParticipationPopup(false);
    setOtp("");
  };

  // Modified handleDownload function

  const handleDownload = () => {
    if (!result) return;

    // If certificateUrl exists (either from API or generated), use it
    if (certificateUrl && certificateUrl.trim() !== "") {
      window.open(certificateUrl, "_blank");
    }
    // Otherwise fall back to HTML2Canvas download
    else if (certificateRef.current) {
      html2canvas(certificateRef.current, { scale: 2 }).then((canvas) => {
        const link = document.createElement("a");
        const userName = result?.name || "user";
        const formattedName = userName.toLowerCase().replace(/\s+/g, "-");
        link.download = `college-mentor-scholarship-2025-certificate-${formattedName}.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
      });
    }
  };

  const shareCertificate = (platform: string) => {
    if (!certificateUrl && !result) return;

    const shareUrl = certificateUrl || window.location.href;
    const userName = result?.name || "user";
    const shareText = `Check out ${userName}'s College Mentor Scholarship Certificate for 2025!`;

    let shareLink = "";
    switch (platform) {
      case "facebook":
        shareLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          shareUrl
        )}`;
        break;
      case "twitter":
        shareLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          shareText
        )}&url=${encodeURIComponent(shareUrl)}`;
        break;
      case "linkedin":
        shareLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          shareUrl
        )}`;
        break;
      case "whatsapp":
        shareLink = `https://api.whatsapp.com/send?text=${encodeURIComponent(
          shareText + " " + shareUrl
        )}`;
        break;
      case "email":
        shareLink = `mailto:?subject=${encodeURIComponent(
          "My College Mentor Scholarship Certificate"
        )}&body=${encodeURIComponent(shareText + " " + shareUrl)}`;
        break;
    }

    window.open(shareLink, "_blank");
  };

  const saveCertificate = async (
    applicationId: number,
    name: string
  ): Promise<string | null> => {
    try {
      setIsCertificateLoading(true);

      // Wait for certificate to be fully rendered
      // Adding a longer delay to ensure the certificate is completely rendered
      await new Promise((resolve) => setTimeout(resolve, 1500));

      // First check if certificate ref exists and is fully rendered
      if (
        !certificateRef.current ||
        !certificateRef.current.offsetHeight ||
        certificateRef.current.offsetHeight < 100
      ) {
        console.error("Certificate is not fully rendered yet");
        // Try again after another delay
        await new Promise((resolve) => setTimeout(resolve, 1500));
        if (!certificateRef.current || !certificateRef.current.offsetHeight) {
          throw new Error("Certificate element is not properly rendered");
        }
      }

      // Reduce scale factor from 2 to 1.5 to decrease image size
      const canvas = await html2canvas(certificateRef.current, {
        scale: 1.5,
        logging: false,
        useCORS: true,
        allowTaint: true,
        // Ensure we capture the full height
        height: certificateRef.current.scrollHeight,
        windowHeight: certificateRef.current.scrollHeight,
      });

      // Convert to blob with reduced quality (0.7 instead of default 0.92)
      const imageBlob = await new Promise<Blob>((resolve) => {
        canvas.toBlob(
          (blob) => {
            if (blob) resolve(blob);
            else resolve(new Blob([]));
          },
          "image/jpeg", // Use JPEG instead of PNG for better compression
          0.7 // Quality factor (0.7 provides good balance between quality and file size)
        );
      });

      // Check file size before uploading (1MB = 1048576 bytes)
      if (imageBlob.size > 1048576) {
        console.warn(
          "Certificate image is too large:",
          (imageBlob.size / 1048576).toFixed(2),
          "MB"
        );

        // If still too large, try an even more aggressive compression
        const compressedBlob = await new Promise<Blob>((resolve) => {
          canvas.toBlob(
            (blob) => {
              if (blob) resolve(blob);
              else resolve(new Blob([]));
            },
            "image/jpeg",
            0.5 // Lower quality for aggressive compression
          );
        });

        // Check if the certificate image was properly created
        if (compressedBlob.size < 1000) {
          // If less than 1KB, probably empty or invalid
          throw new Error("Generated certificate is invalid or too small");
        }

        if (compressedBlob.size > 1048576) {
          throw new Error(
            "Certificate image is still too large after compression"
          );
        }

        // Use the more compressed version
        const userName = name || "user";
        const formattedName = userName.toLowerCase().replace(/\s+/g, "-");
        const fileName = `college-mentor-scholarship-2025-certificate-${formattedName}.jpg`;

        const formData = new FormData();
        formData.append("file", compressedBlob, fileName);

        const response = await axios.post(
          `${config.apiUrl}/api/saveCertificate/${applicationId}`,
          formData,
          {
            headers: {
              accept: "*/*",
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (
          response.data &&
          typeof response.data === "string" &&
          response.data.trim() !== ""
        ) {
          return response.data;
        }
      } else {
        // Check if the certificate image was properly created
        if (imageBlob.size < 1000) {
          // If less than 1KB, probably empty or invalid
          throw new Error("Generated certificate is invalid or too small");
        }

        // If size is acceptable, proceed with the original image
        const userName = name || "user";
        const formattedName = userName.toLowerCase().replace(/\s+/g, "-");
        const fileName = `college-mentor-scholarship-2025-certificate-${formattedName}.jpg`;

        const formData = new FormData();
        formData.append("file", imageBlob, fileName);

        const response = await axios.post(
          `${config.apiUrl}/api/saveCertificate/${applicationId}`,
          formData,
          {
            headers: {
              accept: "*/*",
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (
          response.data &&
          typeof response.data === "string" &&
          response.data.trim() !== ""
        ) {
          return response.data;
        }
      }

      return null;
    } catch (error) {
      console.error("Error saving certificate:", error);
      // Show user-friendly error message about file size if applicable
      if (error instanceof Error && error.message.includes("too large")) {
        setOtpError("Certificate image is too large. Please try again later.");
      } else if (
        error instanceof Error &&
        error.message.includes("not properly rendered")
      ) {
        setOtpError(
          "Certificate couldn't be generated properly. Please try again."
        );
      }
      return null;
    } finally {
      setIsCertificateLoading(false);
    }
  };

  const renderResultText = () => {
    if (!result) return null;

    const awards = [
      result.cash_prize_scholarship_worth &&
        `the Partnered Universities Scholarship worth ${result.cash_prize_scholarship_worth}`,
      result.cash_prize && `a cash prize of ${result.cash_prize}`,
      result.prize && `a special prize of ${result.prize}`,
      `College Mentor Worth Services valued at ${result.college_mentor_worth_services}`,
    ].filter(Boolean);

    const text = result.isWinner
      ? `You have been awarded ${
          awards.length > 1
            ? awards.slice(0, -1).join(", ") + " along with " + awards.slice(-1)
            : awards[0]
        }.`
      : `You have been awarded ${
          awards.length > 1
            ? awards.slice(0, -1).join(", ") + " along with " + awards.slice(-1)
            : awards[0]
        } for your participation in the ${result.CategoryName}.`;

    return (
      <p
        className="text-gray-800 mb-4 max-md:mb-1 text-center text-[16px] max-md:text-[8px] leading-relaxed"
        dangerouslySetInnerHTML={{
          __html: text.replace(
            /(the Partnered Universities Scholarship worth .*?|a cash prize of .*?|a special prize of .*?|College Mentor Worth Services valued at .*?)/g,
            '<span class="text-[#173CBA] font-semibold">$1</span>'
          ),
        }}
      />
    );
  };

  // Request OTP
  const handleVerify = async (): Promise<void> => {
    if (mobileNumber.length !== 10 || !/^\d{10}$/.test(mobileNumber)) {
      setOtpError("Please enter a valid 10-digit mobile number.");
      return;
    }
    setOtp("");
    setIsLoading(true);
    setOtpError(""); // Clear any existing error
    try {
      const response = await axios.post(
        `${config.apiUrl}/api/scholarship/initiate`,
        {
          phoneNumber: mobileNumber,
        },
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
            "X-Auth-Token":
              "e711724f44c71abf0c2794572472ed6edcea55a351f6428fe67060a692aa9316",
          },
        }
      );
      if (response.status >= 200 && response.status < 300) {
        setIsVerified(true);
      }
    } catch (e) {
      if (axios.isAxiosError(e) && e.response?.data?.message) {
        setOtpError(e.response.data.message);
      } else {
        console.error("Error sending OTP:", e);
        setOtpError("An error occurred while sending OTP. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Verify OTP and get results
  const handleSubmit = async (): Promise<void> => {
    if (otp.length === 0) {
      setOtpError("Please enter the OTP.");
      return;
    }

    setIsLoading(true);
    setShowExamNotTakenPopup(false);
    setShowParticipationPopup(false);
    setOtpError(""); // Clear any existing error
    try {
      // Validate OTP
      const otpResponse = await axios.post(
        `${config.apiUrl}/api/scholarship/validate-otp`,
        {
          mobileNumber: mobileNumber,
          otp: otp,
        },
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      const otpData: OtpResponse = otpResponse.data;
      const innerBody = otpData?.data?.body;

      // Check inner statusCode even if HTTP status is 200
      if (innerBody?.statusCode && innerBody.statusCode >= 400) {
        if (
          innerBody.statusCode === 400 &&
          innerBody.message === "Invalid OTP"
        ) {
          setOtpError("Invalid OTP. Please try again.");
          return;
        }
        setOtpError(
          innerBody.message ||
            `OTP validation failed (Code: ${innerBody.statusCode})`
        );
        return;
      }

      const accessToken = innerBody?.accessToken;
      if (!accessToken) {
        setOtpError("No access token received. Please try again.");
        return;
      }

      // Fetch scholarship result
      const resultResponse = await BaseURLAuth.get(
        `${config.apiUrl}/api/scholarship-result`,
        {
          headers: {
            Authorization: accessToken,
          },
        }
      );

      const resultData: ScholarshipResult = resultResponse.data;
      if (resultResponse.status >= 200 && resultResponse.status < 300) {
        if (!resultData || !resultData.name) {
          setOtpError("Invalid scholarship result data received.");
          return;
        }
        if (resultData.statusCode === 404) {
          setShowExamNotTakenPopup(true);
          return;
        }

        // Only show certificate or popup based on isWinner
        if (resultData.isWinner) {
          setResult(resultData);
          setShowCertificateView(true);

          // Check if certificateLink exists in the scholarship-result API response
          if (
            resultData.certificateLink &&
            resultData.certificateLink.trim() !== ""
          ) {
            setCertificateUrl(resultData.certificateLink);
          } else if (resultData.applicationId) {
            // If no certificateLink is provided, immediately generate one
            setIsCertificateLoading(true);
            // Wait for the certificate ref to render before generating
            setTimeout(async () => {
              const newCertificateUrl = await saveCertificate(
                resultData.applicationId!,
                resultData.name!
              );
              setIsCertificateLoading(false);
              if (newCertificateUrl) {
                setCertificateUrl(newCertificateUrl);
              }
            }, 1000);
          }
        } else {
          // Non-winner: show participation popup and exit
          setShowParticipationPopup(true);
          return;
        }
      } else {
        setOtpError(
          `Failed to fetch results (Status: ${resultResponse.status})`
        );
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        const responseData = error.response?.data;
        const innerBody = responseData?.data?.body;

        if (status === 200 && innerBody?.statusCode >= 400) {
          if (
            innerBody.statusCode === 400 &&
            innerBody.message === "Invalid OTP"
          ) {
            setOtpError("Invalid OTP. Please try again.");
          } else {
            setOtpError(
              innerBody.message || `Error (Code: ${innerBody.statusCode})`
            );
          }
        } else if (status === 400) {
          setOtpError(responseData?.message || "Invalid request data.");
        } else if (status === 401) {
          setOtpError("Unauthorized: Please check your credentials.");
        } else if (status === 404) {
          setShowExamNotTakenPopup(true);
          return;
        } else if (status === 503) {
          setOtpError("Service unavailable. Please try again later.");
        } else if (status === 500) {
          setOtpError("Server error. Please try again later.");
        } else {
          setShowExamNotTakenPopup(true);
          console.error("Axios error:", error.response?.data || error.message);
        }
      } else {
        console.error("Unexpected error in handleSubmit:", error);
        setOtpError("An unexpected error occurred. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // New helper function to generate and save certificate
  const generateAndSaveCertificate = (resultData: ScholarshipResult) => {
    if (!resultData || !resultData.applicationId) return;

    setIsCertificateLoading(true);
    // Wait for the certificate ref to render
    setTimeout(async () => {
      // Generate and save the certificate to get a URL
      const newCertificateUrl = await saveCertificate(
        resultData.applicationId!,
        resultData.name!
      );
      setIsCertificateLoading(false);
      if (newCertificateUrl) {
        setCertificateUrl(newCertificateUrl);
      }
    }, 1000);
  };

  // Effect to check and regenerate certificate if needed when result changes
  useEffect(() => {
    if (
      result &&
      !certificateUrl &&
      !isCertificateLoading &&
      result.applicationId
    ) {
      generateAndSaveCertificate(result);
    }
  }, [result, certificateUrl, isCertificateLoading]);

  // Handle input changes
  const handleMobileNumberChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setMobileNumber(e.target.value.replace(/\D/g, ""));
    setOtpError(""); // Clear error when user types
    setShowExamNotTakenPopup(false);
  };

  const handleOtpChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setOtp(e.target.value.replace(/\D/g, ""));
    setOtpError(""); // Clear error when user types
    setShowExamNotTakenPopup(false);
  };

  const closePopup = () => {
    setShowExamNotTakenPopup(false);
    setOtp(""); // Clear OTP when popup is closed
  };

  // Certificate View Component
  const renderCertificateView = () => {
    return (
      <div className="w-full md:min-h-screen flex flex-col items-center justify-center bg-[#FFF9E5] pb-6 pt-3 max-md:pb-3">
        <div className="container mx-auto" style={{ position: "relative" }}>
          {/* Certificate Display */}
          <div className="flex justify-center mb-6mb-1 max-md:">
            <div ref={certificateRef} className="bg-white">
                {result?.isWinner ? (
                  <NewCertificateGenerator
                    defaultName={result?.name
                      ?.split(" ")
                      .map(
                        (word) =>
                          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                      )
                      .join(" ")}
                    defaultContent="For outstanding performance in the <strong> College Mentor Scholarship </strong> Test. Your dedication and excellence have placed you among the top achievers in"
                    defaultCategory={
                      result?.CategoryName ||
                      "Championing Gender Equality - Boys Category"
                    }
                    defaultFinancialAward={
                      // Build an array of awards and join with ' + ', so no trailing plus
                      [
                        result?.cash_prize
                          ? `Cash Prize Worth Rs. ${result.cash_prize}/-`
                          : null,
                        result?.cash_prize_scholarship_worth
                          ? `Partner University Scholarships of Rs. ${result.cash_prize_scholarship_worth}`
                          : null,
                        result?.college_mentor_worth_services
                          ? `College Mentor Services worth Rs. ${result.college_mentor_worth_services}`
                          : null,
                      ]
                        .filter(Boolean)
                        .join(" + ")
                    }
                    defaultCertificateId={`CMS-1${String(
                      result?.applicationId
                    ).padStart(5, "0")}2025`}
                    defaultDate={moment().format("DD/MM/YYYY")}
                  />
                ) : (
                  <NewParticipationCertificate
                    defaultName={result?.name
                      ?.split(" ")
                      .map(
                        (word) =>
                          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                      )
                      .join(" ")}
                    defaultCertificateId={`CMS-1${String(
                      result?.applicationId
                    ).padStart(5, "0")}2025`}
                    defaultDate={moment().format("DD/MM/YYYY")}
                  />
                )}
            </div>
          </div>

          {/* Footer section with social media, download button, and contact info horizontally aligned */}
          <div className="w-full flex flex-col sm:flex-row justify-center sm:justify-between items-center gap-5 max-md:gap-3">
            {/* Share Certificate Section - Left */}
            <div className="flex flex-col items-start gap-3">
              <h3 className="text-xl font-normal text-black m-0">
                Share your Certificate
              </h3>
              <div className="flex items-center gap-3">
                <button
                  onClick={() => shareCertificate("facebook")}
                  className="p-1 bg-blue text-white rounded-md w-6 h-6 flex justify-center items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                  </svg>
                </button>
                <button
                  onClick={() => shareCertificate("linkedin")}
                  className="p-1 bg-blue text-white rounded-md w-6 h-6 flex justify-center items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                  </svg>
                </button>
                <button
                  onClick={() => shareCertificate("twitter")}
                  className="p-1 bg-blue text-white rounded-md w-6 h-6 flex justify-center items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                  </svg>
                </button>
                <button
                  onClick={() => shareCertificate("whatsapp")}
                  className="p-1 bg-blue text-white rounded-md w-6 h-6 flex justify-center items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
                  </svg>
                </button>
                <button
                  onClick={() => shareCertificate("email")}
                  className="p-1 bg-blue text-white rounded-md w-6 h-6 flex justify-center items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M0 3v18h24v-18h-24zm6.623 7.929l-4.623 5.712v-9.458l4.623 3.746zm-4.141-5.929h19.035l-9.517 7.713-9.518-7.713zm5.694 7.188l3.824 3.099 3.83-3.104 5.612 6.817h-18.779l5.513-6.812zm9.208-1.264l4.616-3.741v9.348l-4.616-5.607z" />
                  </svg>
                </button>
                <button
                  onClick={handleDownload}
                  className="p-1 bg-blue text-white rounded-md w-6 h-6 flex justify-center items-center"
                >
                  <MaterialSymbolsDownloadSharp />
                </button>
              </div>
            </div>

            {/* Download Button - Center */}
            {/* <div className="flex justify-center">
              {isCertificateLoading ? (
                <button
                  disabled
                  className="px-6 py-3 bg-gray-400 text-white font-semibold rounded-md cursor-not-allowed"
                >
                  Loading Certificate...
                </button>
              ) : certificateUrl ? (
                <a
                  href={certificateUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-3 bg-[#173CBA] text-white font-semibold rounded-md hover:bg-green transition-colors inline-block"
                >
                  Download Certificate
                </a>
              ) : (
                <button
                  onClick={handleDownload}
                  className="px-6 py-3 bg-[#173CBA] text-white font-semibold rounded-md hover:bg-green transition-colors"
                >
                  Download Certificate
                </button>
              )}
            </div> */}

            {/* Contact Information - Right */}
            <hr className="border-b border-t-0 border-green w-full mx-9 block sm:hidden" />
            <div className="text-center sm:text-right">
              <p className="text-black font-normal">
                For Mentoring, Admissions and Scholarships
              </p>
              <p className="text-xl font-normal text-black">
                Call: <strong>799 71 66 666</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full lg:min-h-[540px] min-max-md:min-h-[600px] overflow-hidden flex-shrink-0 bg-gradient-to-b from-[#EDFCFF] to-[#89C9ED] flex justify-center items-end relative">
      {/* Certificate for printing (hidden off-screen) */}
      {result && !showCertificateView && (
        <div
          style={{
            position: "absolute",
            left: "-9999px",
            isolation: "isolate", // Prevents parent CSS from affecting this
          }}
        >
          <div ref={certificateRef}>
            {result?.isWinner ? (
              <NewCertificateGenerator
                defaultName={result?.name
                  ?.split(" ")
                  .map(
                    (word) =>
                      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                  )
                  .join(" ")}
                defaultContent="For outstanding performance in the <strong> College Mentor Scholarship </strong> Test. Your dedication and excellence have placed you among the top achievers in"
                defaultCategory={
                  result?.CategoryName ||
                  "Championing Gender Equality - Boys Category"
                }
                defaultFinancialAward={`${
                  result?.cash_prize
                    ? `Cash Prize Worth Rs. ${result?.cash_prize} + `
                    : ""
                }Partner University Scholarships of Rs. ${
                  result?.cash_prize_scholarship_worth
                } and College Mentor Services worth Rs. ${
                  result?.college_mentor_worth_services
                }`}
                defaultCertificateId={`CMS-1${String(
                  result?.applicationId
                ).padStart(5, "0")}2025`}
                defaultDate={moment().format("DD / MM / YYYY")}
              />
            ) : (
              <NewParticipationCertificate
                defaultName={result?.name
                  ?.split(" ")
                  .map(
                    (word) =>
                      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                  )
                  .join(" ")}
                defaultCertificateId={`CMS-1${String(
                  result?.applicationId
                ).padStart(5, "0")}2025`}
                defaultDate={moment().format("DD / MM / YYYY")}
              />
            )}
          </div>
        </div>
      )}

      {/* {showExamNotTakenPopup && (
        <PopupInfo
          isOpen={showExamNotTakenPopup}
          onClose={() => setShowExamNotTakenPopup(false)}
          info="It looks like you haven't participated in the College Mentor
              Scholarship Test yet. Don't miss out on amazing scholarship
              opportunities!"
        />
      )} */}
      {showExamNotTakenPopup && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
          <ExamNotTaken onClose={() => setShowExamNotTakenPopup(false)} />
        </div>
      )}

      {showParticipationPopup && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
          <ParticipationPopup onClose={closeParticipationPopup} />
        </div>
      )}

      {/* Show certificate view if OTP is validated and result is available */}
      {showCertificateView && result ? (
        renderCertificateView()
      ) : (
        <div className="container flex justify-between relative max-md:flex-col">
          <div className="w-[327px] max-md:w-full md:absolute lg:-top-12 min-max-md:-top-[37%] lg:left-0 min-max-md:left-[5%]">
            <h3 className="text-[32px] md:h-[150px] font-bold text-[#173CBA] leading-[40px] font-roboto text-left max-md:text-center">
              India's Top NIRF & QS Ranked Universities
            </h3>
          </div>

          <div className="w-[300px] min-max-md:w-[300] md:hidden mt-4 text-center flex flex-col mx-auto leading-6 mb-4">
            <p className="text-[18px] min-max-md:text-[14px] font-bold text-[#173CBA] font-roboto text-center">
              Open Admissions for 2025
            </p>
            <p className="text-[18px]  min-max-md:text-[14px] font-normal text-[#173CBA] font-roboto text-center">
              Through College Mentor Scholarship Test and +2 Marks.
            </p>
          </div>

          <div
            className="flex flex-col stats-bg w-[925px] min-max-md:mt-10 min-max-md:h-[450px] h-[462.5px] min-max-xs:w-[371px] min-max-xss:w-[93%] max-md:h-[184px] bg-[#FFF9E5] rounded-b-full justify-start mx-auto items-center relative"
            style={{ borderRadius: "925px 925px 0 0" }}
          >
            <div
              className={`animate max-lg:hidden ${isHovering ? "paused" : ""}`}
            >
              <ul
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                style={{ whiteSpace: "normal", overflowX: "visible" }}
              >
                {logos.map((logo, index) => (
                  <li
                    key={index}
                    className="w-24 h-24 bg-white p-2  transition-all duration-300 ease-in-out hover:w-[105px] hover:h-[105px] shadow-md rounded-full flex items-center justify-center overflow-hidden"
                  >
                    {logo.slug && logo.slug !== "#" ? (
                      <Link to={`/college-details/${logo.slug}`}>
                        <img
                          src={logo.imageUrl}
                          alt="Logo"
                          className="w-full h-full object-contain p-1"
                        />
                      </Link>
                    ) : (
                      <div>
                        <img
                          src={logo.imageUrl}
                          alt="Logo"
                          className="w-full h-full object-contain p-1"
                        />
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            {result ? (
              <h3 className="text-center font-roboto mt-16 max-md:mt-3 flex flex-col min-max-md:mt-6">
                <span className="text-[#22C55E] text-[36px] max-md:text-[12px] special-word font-bold max-md:leading-4 leading-[48px]">
                  Congratulations
                </span>

                <span className="text-[#173CBA] text-[24px] max-md:text-[10px] font-normal max-md:leading-3 leading-[36px]">
                  {result.name}!
                </span>
              </h3>
            ) : (
              <h1 className="text-[#173CBA] text-center font-roboto text-[24px] max-md:text-[10px] font-normal max-md:leading-3 leading-[36px] mt-16 xl:mt-24 max-md:mt-7">
                College Mentor Scholarship Test <br /> Result 2025
              </h1>
            )}

            <div className="mt-6 max-md:mt-1 flex flex-col items-center gap-1 w-[467px] max-md:w-[71%] z-10">
              {!result ? (
                <>
                  <label className="text-[#747474] max-md:w-[187px] text-left max-md:text-[10px] max-md:leading-3 text-[20px] font-normal leading-[36px] w-full">
                    Mobile Number
                  </label>
                  <div className="w-full flex gap-2 max-md:w-[187px]">
                    <input
                      type="text"
                      placeholder="Your registered mobile number"
                      value={mobileNumber}
                      onChange={handleMobileNumberChange}
                      maxLength={10}
                      className="w-full h-[42px] border max-md:h-[18px] border-[#89C9ED] max-md:text-[10px] max-md:leading-3 focus:outline-none focus:border-[#89C9ED] bg-white px-4 rounded-sm text-[#A3A2AC] text-center"
                    />
                    <button
                      onClick={handleVerify}
                      disabled={isLoading}
                      className="px-3 py-2 bg-[#0C9] text-white font-bold rounded-md max-md:text-[10px] disabled:opacity-50"
                    >
                      {isLoading && !isVerified ? "Sending..." : "Verify"}
                    </button>
                  </div>

                  <div className="w-full relative max-md:w-[187px]">
                    <input
                      type="text"
                      placeholder="OTP"
                      value={otp}
                      onChange={handleOtpChange}
                      disabled={!isVerified || isLoading}
                      className={`w-full h-[42px] border max-md:h-[18px] max-md:text-[10px] max-md:leading-3 focus:outline-none focus:border-[#89C9ED] border-[#89C9ED] bg-white px-4 rounded-md text-[#A3A2AC] text-center mt-4 max-md:mt-1 disabled:opacity-50 ${
                        otpError ? "border-red-500" : ""
                      }`}
                    />
                    {otpError && (
                      <p className="text-red-500 text-sm max-md:text-[10px] mt-1 text-left">
                        {otpError}
                      </p>
                    )}
                  </div>

                  <button
                    onClick={handleSubmit}
                    disabled={!isVerified || otp.length === 0 || isLoading}
                    className="p-3 max-md:py-1 max-md:px-2 bg-[#0C9] max-md:text-[10px] flex justify-center text-white font-bold rounded-md mt-2 max-md:mt-1 items-center disabled:opacity-50"
                  >
                    {isLoading && isVerified ? "Submitting..." : "SUBMIT"}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="12"
                      viewBox="0 0 16 12"
                      fill="none"
                      className="ml-2"
                    >
                      <path
                        d="M1.5 5.25C1.08579 5.25 0.75 5.58579 0.75 6C0.75 6.41421 1.08579 6.75 1.5 6.75L1.5 5.25ZM15.0303 6.53033C15.3232 6.23744 15.3232 5.76256 15.0303 5.46967L10.2574 0.6967C9.96447 0.403806 9.48959 0.403806 9.1967 0.6967C8.90381 0.989593 8.90381 1.46447 9.1967 1.75736L13.4393 6L9.1967 10.2426C8.90381 10.5355 8.90381 11.0104 9.1967 11.3033C9.48959 11.5962 9.96447 11.5962 10.2574 11.3033L15.0303 6.53033ZM1.5 6.75L14.5 6.75L14.5 5.25L1.5 5.25L1.5 6.75Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </>
              ) : (
                <div className="w-full relative">
                  {renderResultText()}
                  <div className="border-t border-b border-gray-300 py-2 my-4 max-md:my-1 max-md:py-1">
                    <p className="text-gray-700 text-center max-md:items-center max-md:justify-between max-md:flex max-md:flex-row min-max-xss:text-[10px] min-max-xs:text-[12px] ">
                      Category:{" "}
                      <span className="font-semibold max-md:text-[10px] max-md:my-auto">
                        {result.CategoryName}
                      </span>{" "}
                      {isCertificateLoading ? (
                        <button
                          disabled
                          className="mt-2 px-4 py-2 max-md:my-auto max-md:px-2 max-md:py-1 bg-gray-400 text-white rounded-md"
                        >
                          Loading Certificate...
                        </button>
                      ) : certificateUrl ? (
                        <a
                          href={certificateUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="mt-2 px-4 py-2 max-md:my-auto max-md:px-2 max-md:py-1 bg-[#173CBA] text-white rounded-md hover:bg-blue-700 transition-colors inline-block"
                          aria-label={`Download College Mentor Scholarship 2025 Certificate for ${result.name}`}
                        >
                          Download Certificate
                        </a>
                      ) : (
                        <button
                          onClick={handleDownload}
                          className="mt-2 px-4 py-2 max-md:my-auto max-md:px-2 max-md:py-1 bg-[#173CBA] text-white rounded-md hover:bg-blue-700 transition-colors"
                        >
                          Download Certificate
                        </button>
                      )}
                    </p>
                  </div>
                  <p className="text-gray-800 text-center min-max-xs:text-[10px] min-max-xss:text-[9px]">
                    For more information, please call:
                    <br />
                    Telangana:{" "}
                    <span className="text-[#173CBA] font-semibold">
                      8959591818 , Andhra Pradesh: 9176407555
                    </span>
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className="w-[299px] md:absolute lg:-top-12 min-max-md:-top-[37%]  md:right-0 min-max-md:right-[5%] max-md:hidden">
            <p className="text-[24px] font-bold text-[#173CBA] leading-[36px] font-roboto text-right">
              Admissions Open for 2025
            </p>
            <p className="text-[20px] font-normal text-[#173CBA] leading-[30px] font-roboto text-right">
              Through College Mentor Scholarship Test and <br />
              +2 Marks.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewScholarshipResultBanner;
